var map = {
	"./auth/auth.module": [
		"./src/app/auth/auth.module.ts"
	],
	"./callback/callback.module": [
		"./src/app/callback/callback.module.ts",
		"callback.module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"dashboard.module"
	],
	"./forecast/forecast.module": [
		"./src/app/forecast/forecast.module.ts",
		"forecast.module"
	],
	"./order/shared/order.module": [
		"./src/app/order/shared/order.module.ts",
		"order.module",
		"common"
	],
	"./reports/shared/reports.module": [
		"./src/app/reports/shared/reports.module.ts",
		"reports.module"
	],
	"./settings/settings.module": [
		"./src/app/settings/settings.module.ts",
		"settings.module",
		"common"
	],
	"./suppliers/suppliers.module": [
		"./src/app/suppliers/suppliers.module.ts",
		"suppliers.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main